const CONCEPT_ONE_HOST_LABELS = new Set(["c1", "concept-one", "conceptone"]);

export function isConceptOneHost(hostname = window.location.hostname): boolean {
  const firstLabel = hostname.toLowerCase().split(".")[0];
  return CONCEPT_ONE_HOST_LABELS.has(firstLabel);
}
